var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fuel container-fluid py-2"},[_c('router-view',{on:{"childrenRoute":_vm.hideNonChildren}}),(!_vm.isChildRoute)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12 pl-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"})])])
}]

export { render, staticRenderFns }